// src/components/SuggestionAutocomplete.tsx
import { Autocomplete, Box, CircularProgress, TextField } from "@mui/material";
import { useSuggestions, Suggestion } from "../../services/useSuggestions";
import { Fragment, useState, useMemo } from "react";

interface Props {
  onSelect: (suggestion: Suggestion | null) => void;
  suggestion: Suggestion | null;
}

export default function SuggestionAutocomplete({
  onSelect,
  suggestion,
}: Props) {
  const [inputValue, setInputValue] = useState("");
  const { data, isFetching } = useSuggestions(
    inputValue.replace(/\d\d\/\d\d - /g, ""),
  );

  const options = useMemo(() => data ?? [], [data]);

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
      <Autocomplete
        isOptionEqualToValue={(option: Suggestion, value: Suggestion) =>
          option.type === value.type && option.id === value.id
        }
        getOptionLabel={(option: Suggestion) => option.label}
        options={options}
        loading={isFetching}
        inputValue={inputValue}
        onInputChange={(_, value) => setInputValue(value)}
        renderInput={(params: any) => (
          <TextField
            {...params}
            label="Asynchronous"
            slotProps={{
              input: {
                ...params.InputProps,
                endAdornment: (
                  <Fragment>
                    {isFetching ? (
                      <CircularProgress color="inherit" size={20} />
                    ) : null}
                    {params.InputProps.endAdornment}
                  </Fragment>
                ),
              },
            }}
          />
        )}
        filterOptions={(x) => x}
        value={suggestion}
        onChange={(_, value) => onSelect(value)}
      />
    </Box>
  );
}
